import Axios from 'axios';
import common from '@/util/common';

// Axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

export default {
	_callBak(content, response,toastCallBack,isShowToast = true) {
		console.log('response', response);
		common.loading(content, 'close');
		if (response.data && response.data.code == 1) {
			return response.data;
		} else if (response.data && response.data.code == 40001) {
			common.gotoIndex(content);
			return false;
		} else {
			if(isShowToast){
				common.toast(response.data.msg, 'error',toastCallBack,response);
				return false;
			}else{
				return response.data;
			}
		}
	},
	_failBack(content, error) {
		common.loading(content, 'close');
		common.toast(error, 'error');
	},
	/* 配置接口 */
	async getConf(param) {
		const content = param.content;
		const url = '/index.php/api/index/getConf';
		common.loading(content, 'open')
		const response = await Axios({
			url: url,
			method: 'post',
			data: param.data,
		});
		return this._callBak(content, response);
	},
	/* 登录接口 */
	async login(param) {
		console.log(process.env.NODE_ENV)
		const content = param.content;
		common.loading(content, 'open')
		const response = await Axios({
			url: param.url,
			method: 'post',
			data: param.data,
		});
		return this._callBak(content, response);
	},
	/* 用户信息接口 */
	async getUserData(param) {
		const content = param.content;
		const url = '/index.php/api/user/getAccountByNo';
		common.loading(content, 'open');
		const response = await Axios({
			url: url,
			method: 'post',
			data: param.data
		});
		return this._callBak(content, response,param.toastCallBack);
	},
	/* 挂失解挂接口 */
	async lostAccount(param) {
		const content = param.content;
		const url = '/index.php/api/user/lostAccount';
		common.loading(content, 'open');
		const response = await Axios({
			url: url,
			method: 'post',
			data: param.data,
		});
		return this._callBak(content, response);
	},
	/* 挂失解挂接口 */
	async setPassword(param) {
		const content = param.content;
		const url = '/index.php/api/user/setPassword';
		common.loading(content, 'open');
		const response = await Axios({
			url: url,
			method: 'post',
			data: param.data,
		});
		return this._callBak(content, response);
	},
	/* 交易记录接口 */
	async transaction(param) {
		const content = param.content;
		const url = '/index.php/api/user/transaction';
		common.loading(content, 'open');
		const response = await Axios({
			url: url,
			method: 'post',
			data: param.data,
		});
		return this._callBak(content, response);
	},
	/* 交易记录加载更多接口 */
	async transactionMore(param) {
		const content = param.content;
		const url = '/index.php/api/user/transaction';
		const response = await Axios({
			url: url,
			method: 'post',
			data: param.data,
		});
		return this._callBak(content, response);
	},
	/* 充值接口 */
	async recharge(param) {
		const content = param.content;
		const url = '/index.php/api/user/recharge';
		common.loading(content, 'open');
		const response = await Axios({
			url: url,
			method: 'post',
			data: param.data,
		});
		return this._callBak(content, response);
	},
	/* 充值j结果页接口 */
	async rechargeResult(param) {
		const content = param.content;
		const url = '/index.php/api/user/rechargeDetail';
		common.loading(content, 'open');
		const response = await Axios({
			url: url,
			method: 'post',
			data: param.data,
		});
		return this._callBak(content, response);
	},
	/* 获取短信 */
	async getCaptcha(param) {
		const content = param.content;
		const url = '/index.php/api/sms/send';
		common.loading(content, 'open');
		const response = await Axios({
			url: url,
			method: 'post',
			data: param.data,
		});
		return this._callBak(content, response);
	},
	/* 注册 */
	async postRegister(param) {
		console.log(param)
		const content = param.content;
		const url = '/index.php/api/user/register';
		common.loading(content, 'open');
		const response = await Axios({
			url: url,
			method: 'post',
			data: param.data,
		});
		return this._callBak(content, response);
	},
	/* 找回密码 */
	async postChangePwd(param) {
		console.log(param)
		const content = param.content;
		const url = '/index.php/api/user/changePwd';
		common.loading(content, 'open');
		const response = await Axios({
			url: url,
			method: 'post',
			data: param.data,
		});
		return this._callBak(content, response);
	},
	/* 获取学生卡 */
	async postGetCard(param) {
		console.log(param)
		const content = param.content;
		const url = '/index.php/api/user/getCard';
		common.loading(content, 'open');
		const response = await Axios({
			url: url,
			method: 'post',
			data: param.data,
		});
		return this._callBak(content, response);
	},
	/* 绑定/解绑学生卡 */
	async postBindCard(param) {
		console.log(param)
		const content = param.content;
		const url = '/index.php/api/user/bindCard';
		common.loading(content, 'open');
		const response = await Axios({
			url: url,
			method: 'post',
			data: param.data,
		});
		return this._callBak(content, response);
	},
	/* 注销 */
	async postSignOut(param) {
		console.log(param)
		const content = param.content;
		const url = '/index.php/api/user/signOut';
		common.loading(content, 'open');
		const response = await Axios({
			url: url,
			method: 'post',
			data: param.data,
		});
		return this._callBak(content, response);
	},
	/* 获取微信登陆appid */
	async postWxLogin(param) {
		console.log(param)
		const content = param.content;
		const url = '/index.php/api/wx/wxLogin';
		common.loading(content, 'open');
		const response = await Axios({
			url: url,
			method: 'post',
			data: param.data,
		});
		return this._callBak(content, response);
	},
	/* 微信授权登录 */
	async postRedirect(param) {
		console.log(param)
		const content = param.content;
		const url = '/index.php/api/wx/redirect';
		common.loading(content, 'open');
		const response = await Axios({
			url: url,
			method: 'post',
			data: param.data,
		});
		return this._callBak(content, response);
	},
	/* 微信支付 */
	async wxRecharge(param) {
		const content = param.content;
		const url = '/index.php/api/wx/recharge';
		common.loading(content, 'open');
		const response = await Axios({
			url: url,
			method: 'post',
			data: param.data,
		});
		return this._callBak(content, response);
	},
	/* 微信支付结果查询 */
	async getPayInfo(param) {
		const content = param.content;
		const url = '/index.php/api/wx/getPayInfo';
		common.loading(content, 'open');
		const response = await Axios({
			url: url,
			method: 'post',
			data: param.data,
		});
		return this._callBak(content, response);
	},
	/* 支付宝支付 */
	async zfbRecharge(param) {
		const content = param.content;
		const url = '/index.php/api/ali/recharge';
		common.loading(content, 'open');
		const response = await Axios({
			url: url,
			method: 'post',
			data: param.data,
		});
		return this._callBak(content, response);
	},
	/* 建行支付 */
	async bankRecharge(param) {
		const content = param.content;
		const url = '/index.php/api/bank/recharge';
		common.loading(content, 'open');
		const response = await Axios({
			url: url,
			method: 'post',
			data: param.data,
		});
		return this._callBak(content, response);
	},
	/* 建行免密登录 */
	async bankAutoLogin(param) {
		const content = param.content;
		const url = '/index.php/api/user/udidLogin';
		common.loading(content, 'open');
		const response = await Axios({
			url: url,
			method: 'post',
			data: param.data,
		});
		return this._callBak(content, response,'',false);
	},
  /* 获取二维码接口 */
  async postGetQrCode(param) {
    const content = param.content;
    const url = '/index.php/api/user/qrCode';
    common.loading(content, 'open');
    const response = await Axios({
      url: url,
      method: 'post',
      data: param.data,
    });
    return this._callBak(content, response);
  },
}
